<script>
  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"

  let {
    RailsApp,
    processing = false,
    type = 'submit',
    disabled = false,
    class: className = '',
    content,
    'aria-label': ariaLabel = '',
    ...restProps
  } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  const isDisabled = $derived(processing || disabled)
  const effectiveAriaLabel = $derived(processing ? i18n.t('form_actions.in_progress') : ariaLabel)
</script>

<button type={type} class={className} disabled={isDisabled} aria-label={effectiveAriaLabel} {...restProps}>
  {#if processing}
    <img src="{RailsApp.Assets.spinner}" class="me-1" alt="{i18n.t('form_actions.in_progress')}" style="width: 1rem; height: 1rem;" />
    {i18n.t('form_actions.in_progress')}
  {:else}
    {@render content()}
  {/if}
</button>
